import React from 'react';
import CreateDocumentsTemplateForm from './CreateDocumentsTemplateForm';
import { IconButton, IconType, usePopupFormManager } from 'features/nekst-widgets';
import { useShowContextRequired } from 'ui-builder';
import { DocumentsTemplate } from 'nekst-api';

export default function CopyTemplateButton() {

  const popupManager = usePopupFormManager();
  const showContext = useShowContextRequired<DocumentsTemplate>();

  const template = showContext.data;

  return (
    <IconButton
      onClick={() => {
        popupManager.openForm(
          <CreateDocumentsTemplateForm
            title={`Copy template "${template.name}"`}
            initialData={{
              name: `Copy of ${template.name}`,
              labelsIds: template.labelsIds,
            }}
          />,
        );
      }}
      type={IconType.COPY}
      title="Copy Template"
    />
  );
}
